import uniq from 'lodash/uniq'
import {
  OfferPricingType,
  OfferType,
} from 'src/common/apollo/types/swarmx/graphql'
import { Offer } from 'src/common/types/models/Offer'
import { OfferWithTake } from './findBestOffers'

export const isBlockOffer = (offer: { offerType: OfferType }) =>
  offer.offerType === OfferType.BlockOffer

export const isFixedOffer = (offer: {
  offerPrice: {
    pricingType: OfferPricingType
  }
}) => offer.offerPrice.pricingType === OfferPricingType.FixedPricing

export const isAuthorizedOffer = (offer: {
  authorizationAddresses: Offer['authorizationAddresses']
}) => {
  return offer.authorizationAddresses && offer.authorizationAddresses.length > 0
}

export const containsAuthorizedOffer = (
  offers: { authorizationAddresses: Offer['authorizationAddresses'] }[]
) => {
  return offers.some(offer => isAuthorizedOffer(offer))
}

export const getAuthAddressesFromOffers = (offers: Offer[]) => {
  return uniq(
    offers
      .filter(offer => !!offer.authorizationAddresses)
      .reduce<string[]>(
        (acc, offer) => [...acc, ...(offer.authorizationAddresses || [])],
        []
      )
  )
}

export const isUserAuthorizedForOffer = (
  offer: Pick<OfferWithTake, 'isFullyAuthorized'>
) => {
  return offer.isFullyAuthorized || offer.isFullyAuthorized === null
}

export const containsUserNotAuthorizedOffers = (
  offers: Pick<OfferWithTake, 'isFullyAuthorized'>[]
) => {
  return offers.some(offer => !isUserAuthorizedForOffer(offer))
}
